import axiosClient from './axiosClient';

const telemetryController = {
  saveEntityAttributesV1(token, entityType, entityId, data) {
    const url = `/api/plugins/telemetry/${entityType}/${entityId}/SERVER_SCOPE`;
    const payload = data;
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
  saveEntityAttributesV2(token, entityType, entityId, data) {
    const url = `/api/plugins/telemetry/${entityType}/${entityId}/attributes/SERVER_SCOPE`;
    const payload = data;
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
  getAttributesByScope(token, entityType, entityId, keys) {
    const url = `/api/plugins/telemetry/${entityType}/${entityId}/values/attributes/SERVER_SCOPE?keys=${keys}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getTimeseries(token, deviceId, keys, startTs, endTs, limit = 1000) {
    const url = `/api/plugins/telemetry/DEVICE/${deviceId}/values/timeseries?startTs=${startTs}&endTs=${endTs}&keys=${keys}&limit=${limit}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getPermission(token, entityType, entityId) {
    const url = `/api/plugins/telemetry/${entityType}/${entityId}/values/attributes`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default telemetryController;
